import { apiURL, baseURL, bulkOpsUrl } from 'config/baseURL';
import API, { gatewayFetch } from 'helpers/api';
import { downloadArrayBuffer, downloadURL } from 'utils/download';
import { queryStringify } from 'utils/router';
import moment from 'moment';
import { toast } from 'helpers/toast';
import { getSessionAuthorizationFor } from 'helpers/sessionAuth';

/** Authorization for a request to `target`: the session when the gateway serves it, else an internal JWT. */
export const getInternalToken = async (token: string, target: string): Promise<string> => {
	const session = await getSessionAuthorizationFor(target, token, gatewayFetch);
	if (session) return session;
	const url = `${apiURL}/auth/retrieve-jwt`;
	const response = await gatewayFetch(url, {
		headers: {
			'x-firebase-token': token,
		},
	});
	if (!response.ok) return '';
	const result = await response.json();
	return (result as { data: string }).data;
};

export const downloadTemplate = async (payload: any, isValidationOnly: boolean): Promise<any> => {
	try {
		const query = JSON.stringify({
			entities: payload.entities ?? [],
			questionnaireIds: payload.entities.includes('questionnaires') ? payload.questionnaireID ?? [] : [],
			siteIDs: payload.siteIDs && payload.siteIDs.length > 0 ? payload.siteIDs : [],
			departmentIDs: payload.departmentIDs && payload.departmentIDs.length > 0 ? payload.departmentIDs : [],
			userIDs: payload.userIDs && payload.userIDs.length > 0 ? payload.userIDs : [],
			startDate: payload.entities.includes('schedules') ? payload.startDate ?? null : null,
			endDate: payload.entities.includes('schedules') ? payload.endDate ?? null : null,
			isValidationOnly: isValidationOnly,
			scheduleOptions: payload.entities.includes('schedules') ? payload.scheduleOptions ?? null : null,
		});
		const authToken = await API.getFirebaseToken();
		const url = `${bulkOpsUrl}/bulk-edit/download`;
		const options = {
			method: 'POST',
			headers: {
				Authorization: await getInternalToken(authToken, url),
				'Content-Type': 'application/json',
			},
			body: query,
		};

		const response = await gatewayFetch(url, options);
		const responseJson = await response.json();

		if (isValidationOnly) {
			return responseJson;
		} else {
			if (response.status !== 200) {
				return responseJson;
			}
			const responseData = await responseJson.data;
			if (responseData) {
				downloadURL(responseData, `nimbly-bulk-edit-template-${moment().format('DD-MM-YY')}.xlsx`);
				return response;
			}
		}
	} catch (error) {
		toast.error(error);
	}
};
